/* @flow */

import { includes, chain } from 'lodash'

import type {
  RootState,
  Action,
  Icon,
  IconId,
  IconsStore,
  IconsQuery,
} from '../types'
import {
  upsert,
  parseIntOr,
  EmbedError,
  ActionRequiresPropertyError,
} from '../helpers'
import { selectCustomerById } from './customersStore'

import { ICON_UPLOAD_SUCCESS } from '../stores/icons/creation'

export const DEFAULT_ICON_SIZE: number = 42

export const INTO_ICONS_STORE: string = 'opinary/INTO_ICONS_STORE'

export function intoIconsStore(items: Array<Icon>): Action {
  return {
    type: INTO_ICONS_STORE,
    items,
  }
}

function embedAssociated(rootState: RootState, item: Icon): Icon {
  const customer = selectCustomerById(rootState, item.customerId)
  if (customer == null) {
    throw new EmbedError(
      { name: 'icon', id: item.id },
      { name: 'customer', id: item.customerId }
    )
  }

  return Object.assign({}, item, {
    customer,
  })
}

export function selectIconsByQuery(
  rootState: RootState,
  query: IconsQuery
): Array<Icon> {
  let seq = chain(rootState.iconsStore)
    .values()
    .map(item => {
      return embedAssociated(rootState, item)
    })

  if (query.search != null) {
    const search = query.search.toLowerCase()
    seq = seq.filter(item => {
      if (item.name == null) return false
      return (
        includes(item.name.toLowerCase(), search) ||
        includes(
          item.customer && item.customer.name
            ? item.customer.name.toLowerCase()
            : '',
          search
        )
      )
    })
  }

  if (query.onlyCustomerId) {
    seq = seq.filter(item => {
      return item.customerId === query.onlyCustomerId
    })
  }

  const limit = query.perPage
  const offset = query.page * query.perPage

  return seq
    .drop(offset)
    .take(limit)
    .value()
}

export function selectIconById(rootState: RootState, id: IconId): ?Icon {
  const item = rootState.iconsStore[id.toString()]
  if (item == null) {
    return null
  }

  return embedAssociated(rootState, item)
}

export default function reducer(
  state: IconsStore = {},
  action: Action
): IconsStore {
  switch (action.type) {
    case ICON_UPLOAD_SUCCESS:
      if (!action.payload || !action.payload.icon) {
        throw new ActionRequiresPropertyError(ICON_UPLOAD_SUCCESS, 'icon')
      } else {
        return upsert(state, [action.payload.icon])
      }
    case INTO_ICONS_STORE:
      if (!action.items) {
        throw new ActionRequiresPropertyError(INTO_ICONS_STORE, 'items')
      } else {
        return upsert(state, action.items)
      }
    default:
      return state
  }
}

export function parseIconsQuery(query: Object): IconsQuery {
  const result = {}

  if (query.search != null && query.search.trim() !== '') {
    result.search = query.search
  }

  if (query.onlyCustomerId != null && query.onlyCustomerId !== '') {
    result.search = query.onlyCustomerId
  }

  result.page = parseIntOr(query.page, 0)
  result.perPage = parseIntOr(query.per_page, 15)

  return result
}



// WEBPACK FOOTER //
// ./src/stores/iconsStore.js